import React from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch } from "hooks";
import { Layout } from "components";

/**
 * this page taking machine_name from url and call getPublicPageDetails with this name and display the results (title, full_text)
 */

export default function Custom() {
  const { machine_name } = useParams();
  const [detailsResponse, detailsRequest] = useFetch(
    `getPublicPageDetails?machine_name=${machine_name}`
  );

  React.useEffect(() => {
    detailsRequest();
  }, [machine_name, detailsRequest]);

  return (
    <Layout>
      <div id="not_found_page" className="page_container pt-5">
        <section className="mb-3">
          <Container>
            <Row>
              <Col>
                <h1 className="text-primary mb-3">
                  {detailsResponse.result.data &&
                    detailsResponse.result.data.title}
                </h1>
              </Col>
            </Row>
            <Row>
              <Col
                className="Container"
                dangerouslySetInnerHTML={{
                  __html:
                    detailsResponse.result.data &&
                    detailsResponse.result.data.full_text,
                }}
              ></Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
}
